import { FREIGHT_PROVIDER_ID } from '@shipstation/client-common/ltl/constants';

// WWEX freight provider ID (from freight_provider database table)
export const WWEX_FREIGHT_PROVIDER_ID = FREIGHT_PROVIDER_ID.Wwex;

// Hardcoded contact type per API requirements
export const OPERATIONS_MANAGER_CONTACT_TYPE = 'OperationsManager';
